import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPurchaseReciept = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Purchase Receipt',
    body
  );
  return data;
});
export const updatePurchaseReciept = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Purchase Receipt/${id}`,
    body
  );
  return data;
});

export const getPurchaseReciept = catchAsync(
  async ({ key = '', value = '' }) => {
    let baseUrl =
      '/api/resource/Purchase Receipt?fields=["name","supplier_name","grand_total","posting_date","docstatus","status","rounded_total","is_return"]&filters=[["is_return","=", "0"]]&order_by=name desc&limit_start=0&limit_page_length=0';
    if (value) {
      if (key === 'posting_date') {
        baseUrl += `&filters=[["posting_date","Between",["${value}","${value}"]]]`;
      } else {
        baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
      }
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);
export const getPurchaseReturn = catchAsync(
  async ({ key = '', value = '' }) => {
    let baseUrl =
      '/api/resource/Purchase Receipt?fields=["name","supplier_name","grand_total","posting_date","status","rounded_total","is_return"]&filters=[["is_return","=", "1"]]&order_by=name desc&limit_start=0&limit_page_length=0';
    if (value) {
      if (key === 'posting_date') {
        baseUrl += `&filters=[["posting_date","Between",["${value}","${value}"]]]`;
      } else {
        baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
      }
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);
export const deletePurchaseReciept = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Purchase Receipt/${record}`
  );
  return data;
});
export const getPurchaseRecieptDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Purchase Receipt/${id}`
  );
  return data;
});
export const getMakePurchaseReciept = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=Make Purchase Receipt&source=${id}`
  );
  return data;
});
export const getMapReferenceMakePR = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=Make PR&source=${id}`
  );
  return data;
});
export const getMapReferenceMakePI = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=Make PI&source=${id}`
  );
  return data;
});
export const getOrderItemDetails = catchAsync(
  async (type, itemName, priceList) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_item_details?type=${type}&item=${itemName}&price_list=${priceList}`
    );
    return data;
  }
);
export const getMapReferencePR = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=PR Return&source=${id}`
  );
  return data;
});
